// extracted by mini-css-extract-plugin
export default {"text":"Results_text__eK1H2","empty":"Results_empty__Oq9uW","graphic":"Results_graphic__4ioL3"};